/* AUTH0 CREDENTIALS */
export const AUTH0_DOMAIN = process.env['REACT_APP_AUTH0_DOMAIN']
export const AUTH0_CLIENT_ID = process.env['REACT_APP_AUTH0_CLIENT_ID']
export const AUTH0_CLIENT_SECRET = process.env['REACT_APP_AUTH0_CLIENT_SECRET']
export const AUTH0_CALLBACK_URL = process.env['REACT_APP_AUTH0_CALLBACK_URL']
export const DOMAIN = process.env['REACT_APP_DOMAIN']
